var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:[_vm.size, _vm.type, _vm.isDisabled && 'disabled'],on:{"click":_vm.onClick}},[(_vm.isLoading)?_c('span',{staticClass:"spinner"}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }